/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TuitionRateType } from './TuitionRateType';
import {
    TuitionRateTypeFromJSON,
    TuitionRateTypeFromJSONTyped,
    TuitionRateTypeToJSON,
    TuitionRateTypeToJSONTyped,
} from './TuitionRateType';

/**
 * 
 * @export
 * @interface CreateTuitionRatePlanRequest
 */
export interface CreateTuitionRatePlanRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTuitionRatePlanRequest
     */
    name: string;
    /**
     * 
     * @type {TuitionRateType}
     * @memberof CreateTuitionRatePlanRequest
     */
    rateType: TuitionRateType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTuitionRatePlanRequest
     */
    isActive: boolean;
}



/**
 * Check if a given object implements the CreateTuitionRatePlanRequest interface.
 */
export function instanceOfCreateTuitionRatePlanRequest(value: object): value is CreateTuitionRatePlanRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rateType' in value) || value['rateType'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function CreateTuitionRatePlanRequestFromJSON(json: any): CreateTuitionRatePlanRequest {
    return CreateTuitionRatePlanRequestFromJSONTyped(json, false);
}

export function CreateTuitionRatePlanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTuitionRatePlanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'rateType': TuitionRateTypeFromJSON(json['rateType']),
        'isActive': json['isActive'],
    };
}

export function CreateTuitionRatePlanRequestToJSON(json: any): CreateTuitionRatePlanRequest {
    return CreateTuitionRatePlanRequestToJSONTyped(json, false);
}

export function CreateTuitionRatePlanRequestToJSONTyped(value?: CreateTuitionRatePlanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'rateType': TuitionRateTypeToJSON(value['rateType']),
        'isActive': value['isActive'],
    };
}

